import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import WhatsAppIcon from "./icons/WhatsAppIcon";
import { BUSINESS } from "../lib/business";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-slate-950 text-slate-300 pt-16 pb-8"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
                    <div className="md:col-span-5">
                        <img
                            src={BUSINESS.logoWhite}
                            alt="Call The Handyman"
                            className="h-14 w-auto mb-5"
                            data-testid="footer-logo"
                        />
                        <p className="text-slate-400 leading-relaxed max-w-md">
                            A reliable, local handyman service covering
                            Dumbarton and the surrounding areas. From quick
                            fixes to bigger projects — one call, job done.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <a
                                href={BUSINESS.facebookUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Call The Handyman on Facebook"
                                data-testid="footer-facebook"
                                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/5 border border-white/10 hover:bg-[#1877F2] hover:border-[#1877F2] text-white transition-all"
                            >
                                <Facebook className="w-5 h-5" />
                            </a>
                            <a
                                href={BUSINESS.facebookUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-facebook-text"
                                className="text-sm text-slate-400 hover:text-white transition-colors"
                            >
                                Follow us on Facebook
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white mb-4">
                            Services
                        </h4>
                        <ul className="space-y-2 text-sm">
                            {[
                                "Plumbing",
                                "Electrical",
                                "Decorating",
                                "Fencing",
                                "Flat-pack assembly",
                                "TV mounting",
                                "Hanging doors",
                                "Odd jobs",
                            ].map((s) => (
                                <li key={s}>
                                    <a
                                        href="#services"
                                        className="hover:text-amber-400 transition-colors"
                                    >
                                        {s}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h4 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white mb-4">
                            Contact
                        </h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href={`tel:${BUSINESS.phoneTel}`}
                                    data-testid="footer-phone"
                                    className="flex items-center gap-3 hover:text-amber-400 transition-colors"
                                >
                                    <Phone className="w-4 h-4 shrink-0" />
                                    {BUSINESS.phone}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={BUSINESS.whatsappUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-whatsapp"
                                    className="flex items-center gap-3 hover:text-[#25D366] transition-colors"
                                >
                                    <WhatsAppIcon className="w-4 h-4 shrink-0" />
                                    Chat on WhatsApp
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${BUSINESS.email}`}
                                    data-testid="footer-email"
                                    className="flex items-center gap-3 hover:text-amber-400 transition-colors break-all"
                                >
                                    <Mail className="w-4 h-4 shrink-0" />
                                    {BUSINESS.email}
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <MapPin className="w-4 h-4 shrink-0" />
                                {BUSINESS.area}
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-slate-500">
                    <div data-testid="footer-copyright">
                        © {new Date().getFullYear()} {BUSINESS.name}. All
                        rights reserved.
                    </div>
                    <div>{BUSINESS.tagline}</div>
                </div>
            </div>
        </footer>
    );
}
